module.exports = __webpack_public_path__ + "static/img/img-2.bf9fe95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-2.jpg
// module id = NRep
// module chunks = 0